/**
 * Labels as toggle chips. Multi-select, so it stays inline rather than opening
 * a sheet — labels are the one field people apply two or three of at a time,
 * and a dialog per toggle would be three dialogs.
 */
import { cn } from "@/lib/utils";
import type { EntryLabel } from "./types";

export function LabelChips({
  labels,
  selectedIds,
  onChange,
}: {
  labels: EntryLabel[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}) {
  if (labels.length === 0) return null;

  const toggle = (id: string) =>
    onChange(
      selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id],
    );

  return (
    <div className="flex flex-wrap gap-1.5">
      {labels.map((label) => {
        const on = selectedIds.includes(label.id);
        return (
          <button
            key={label.id}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(label.id)}
            className={cn(
              "flex min-h-8 items-center gap-1.5 rounded-[var(--cp-r-pill)] border px-2.5 py-1 text-[11.5px] transition-colors",
              on
                ? "border-[var(--cp-accent)] bg-[var(--cp-accent-wash)] text-[var(--cp-accent-ink)]"
                : "border-[var(--cp-line)] text-[var(--cp-ink-2)] hover:bg-[var(--cp-surface-2)]",
            )}
          >
            {label.color && (
              <span
                aria-hidden
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: label.color }}
              />
            )}
            {label.name}
          </button>
        );
      })}
    </div>
  );
}
